import React, { FC } from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const AddUserForm = lazyLoader(
  () => import("Containers/User/AddUserForm/AddUserForm")
);

export const AddUser: FC = () => {
  return (
    <Layout>
      <AddUserForm />
    </Layout>
  );
};
